import { Box, Chip, Stack, Typography } from "@mui/material";
import { V2_COLORS } from "@/pages/InvoiceManagement/v2/constants/colors";
import type { VendorRfqQuery } from "../../types";
import { formatRespondBy } from "../../utils/deadline";

interface QuestionThreadProps {
  queries: VendorRfqQuery[];
}

export default function QuestionThread({ queries }: QuestionThreadProps) {
  if (queries.length === 0) return null;

  return (
    <Stack data-testid="question-thread" aria-live="polite" spacing={1}>
      {queries.map((query) => {
        const answered = query.status === "ANSWERED";
        return (
          <Box key={query.query_id} sx={{ borderLeft: `3px solid ${answered ? V2_COLORS.success : V2_COLORS.warning}`, pl: 1.5 }}>
            <Typography fontSize="13px" fontWeight={500} sx={{ whiteSpace: "pre-wrap" }}>
              {`“${query.text}”`}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
              <Typography fontSize="11px" sx={{ color: V2_COLORS.textSecondary }}>
                {`Asked ${formatRespondBy(query.raised_at)}`}
              </Typography>
              {!answered && <Chip size="small" label="Awaiting answer" sx={{ fontWeight: 600, color: V2_COLORS.warning, backgroundColor: V2_COLORS.warningBg }} />}
            </Stack>
            {answered && (
              <Box sx={{ mt: 0.5 }}>
                <Typography fontSize="13px" sx={{ whiteSpace: "pre-wrap" }}>
                  {query.answer}
                </Typography>
                <Typography fontSize="11px" sx={{ color: V2_COLORS.success }}>
                  {`Answered ${formatRespondBy(query.answered_at)}`}
                </Typography>
              </Box>
            )}
          </Box>
        );
      })}
    </Stack>
  );
}
